import { matchPath } from 'react-router-dom'

type DetailRouteFallback = {
  pattern: string
  fallbackPath: string
}

const detailRouteFallbacks: DetailRouteFallback[] = [
  { pattern: '/retail', fallbackPath: '/' },
  { pattern: '/orders/:id', fallbackPath: '/orders' },
  { pattern: '/orders/divide/:id', fallbackPath: '/orders' },
  { pattern: '/returns/create', fallbackPath: '/returns' },
  { pattern: '/returns/:id', fallbackPath: '/returns' },
  { pattern: '/fbo/create', fallbackPath: '/fbo' },
  { pattern: '/fbo/write-off', fallbackPath: '/fbo' },
  { pattern: '/categories/create', fallbackPath: '/categories' },
  { pattern: '/categories/:id/edit', fallbackPath: '/categories' },
  { pattern: '/kits/create', fallbackPath: '/kits' },
  { pattern: '/kits/:id/edit', fallbackPath: '/kits' },
  { pattern: '/inventory/create', fallbackPath: '/inventory' },
  { pattern: '/inventory/:id', fallbackPath: '/inventory' },
  { pattern: '/assembly/orders/:type', fallbackPath: '/assembly/orders' },
  { pattern: '/stores/:id/edit', fallbackPath: '/stores' },
  { pattern: '/information/:id', fallbackPath: '/information' },
  {
    pattern: '/shipping/checking/:id/view',
    fallbackPath: '/shipping/orders',
  },
  { pattern: '/shipping/:id/bulk/view', fallbackPath: '/fbo' },
  { pattern: '/shipping/:id/bulk/assembling', fallbackPath: '/fbo' },
  { pattern: '/assembly/:id/items', fallbackPath: '/assembly/orders' },
  { pattern: '/tickets/:ticketId', fallbackPath: '/tickets' },
  { pattern: '/customers/:id', fallbackPath: '/customers' },
  { pattern: '/kvants/:id', fallbackPath: '/kvants' },
  {
    pattern: '/settings-shipping/:code/:storeId/zone',
    fallbackPath: '/settings-shipping',
  },
  { pattern: '/users/:id/edit', fallbackPath: '/users' },
  { pattern: '/profile/:id/edit', fallbackPath: '/profile' },
  { pattern: '/userRoles/:id/edit', fallbackPath: '/settings' },
]

export const getDetailBackButtonFallback = (pathname: string) =>
  detailRouteFallbacks.find(({ pattern }) =>
    matchPath({ path: pattern, end: true }, pathname),
  )?.fallbackPath || null
